import AxiosCustom from "../../../../components/common/apiConfigPouyan/index";


export function send_contract_otp_api(payload) {
  const config = {
    url: `/UpdateContract/SendContractOTP/SendContractOTP`
  };

  const data = {};


  const header = {
    ...payload?.headers
  }

  return AxiosCustom(config, data, header);
}
